import translations from '../locales/translations';

/**
 * Normalize a cell value for text column filters so filter input matches
 * what the table displays (booleans render as Yes/No, not true/false).
 */
export function columnFilterText(value: unknown): string {
  if (typeof value === 'boolean') {
    return value ? translations.en.yes : translations.en.no;
  }
  if (value === undefined || value === null) {
    return '';
  }
  return String(value);
}

/**
 * Whether a cell value matches a column filter query.
 * Booleans match Yes/No (display) and true/false (raw aliases).
 */
export function matchesColumnFilter(value: unknown, filterQuery: string): boolean {
  const q = filterQuery.trim().toLowerCase();
  if (!q) return true;

  if (typeof value === 'boolean') {
    const display = (value ? translations.en.yes : translations.en.no).toLowerCase();
    const alias = value ? 'true' : 'false';
    return display.includes(q) || alias.startsWith(q);
  }

  return columnFilterText(value).toLowerCase().includes(q);
}
